// extracted by mini-css-extract-plugin
module.exports = {"ra-topbar-destinations":"ra-topbar-destinations_ra-topbar-destinations__XUhiN","ra-topbar-destinations__open":"ra-topbar-destinations_ra-topbar-destinations__open__EaXy9"};